import PigmentCodeBanner from "./components/banner/index.vue";
import PigmentCodeProgram from "./components/program/index.vue";
import PigmentCodeWhatYouGet from "./components/what-you-get/index.vue";
import PigmentCodeFormat from "./components/format/index.vue";
import PigmentCodeSlider from "./components/slider/index.vue";
import PigmentCodeImage from "./components/image/index.vue";
import PigmentCodeEvents from "./components/events/index.vue";
import PigmentCodeList from "./components/list/index.vue";
import { globalLoader } from "../../helpers/variables";
import { mapActions, mapGetters } from "vuex";
import dynamicsHead from "@/mixins/dynamics-head";

export default {
    name: "PigmentCodePage",
    props: {},
    emits: [],
    components: {
      PigmentCodeFormat,
      PigmentCodeWhatYouGet,
      PigmentCodeProgram,
      PigmentCodeBanner,
      PigmentCodeSlider,
      PigmentCodeImage,
      PigmentCodeEvents,
      PigmentCodeList
    },
    setup() {},
    data() {
        return {}
    },
    mixins: [dynamicsHead],
    async created() {
      globalLoader(true)
      await Promise.all([
        this.fetchPigmentCode(),
        this.fetchTickets(),
      ]);
      globalLoader(false)

      this.setPageMetaInfo(this.content)
    },
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "pigmentCode/content",
      })
    },
    methods: {
      ...mapActions({
        fetchPigmentCode: "pigmentCode/FETCH_PIGMENT_CODE",
        fetchTickets: "pigmentCode/FETCH_TICKETS",
      })
    }
}
